export enum JourneyNodeType {
  eventEntry = "event-entry",
  timeDelay = "time-delay",
  triggerCheck = "trigger-check",
  sendPush = "send-push",
  exit = "exit",
  start = "start",
  end = "end",
}
